


























import { Component, Vue, Prop} from 'vue-property-decorator';
import { Effect } from '@/game/effect';

@Component({
  name: 'timer',
})
export default class Timer extends Vue {

  @Prop() public duration!: number;
  public run = false;

  public mounted() {
    window.requestAnimationFrame(() => {
      setTimeout(() => {
        this.run = true;
      });
    });
  }
}
